import { render, staticRenderFns } from "./RealResourceProvider.vue?vue&type=template&id=3552b14a&scoped=true&"
import script from "./RealResourceProvider.vue?vue&type=script&lang=ts&"
export * from "./RealResourceProvider.vue?vue&type=script&lang=ts&"
import style0 from "./RealResourceProvider.vue?vue&type=style&index=0&id=3552b14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552b14a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VRow})
